import { render } from "./IconRead.vue?vue&type=template&id=84078402"
import script from "./IconRead.vue?vue&type=script&lang=js"
export * from "./IconRead.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__